import { useEffect } from "react";
import { useSnackbar, OptionsObject, SnackbarKey, SnackbarMessage } from "notistack";

let enqueueSnackbarRef: ((message: SnackbarMessage, options?: OptionsObject) => SnackbarKey) | null = null;
let closeSnackbarRef: ((key?: SnackbarKey) => void) | null = null;

/**
 * 掛載在 SnackbarProvider 底下(僅需一次)，讓非 React 元件(例如 function.ts 內的工具函式)
 * 也能呼叫 enqueueSnackbar / closeSnackbar，不需要每個呼叫端各自傳入。
 */
export const GlobalSnackbarCapture = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    useEffect(() => {
        enqueueSnackbarRef = enqueueSnackbar;
        closeSnackbarRef = closeSnackbar;
        return () => {
            enqueueSnackbarRef = null;
            closeSnackbarRef = null;
        };
    }, [enqueueSnackbar, closeSnackbar]);
    return null;
};

export const globalEnqueueSnackbar = (message: SnackbarMessage, options?: OptionsObject): SnackbarKey | undefined =>
    enqueueSnackbarRef?.(message, options);

export const globalCloseSnackbar = (key?: SnackbarKey): void => closeSnackbarRef?.(key);
